module.exports = __webpack_public_path__ + "static/img/BJ.34065dc6.png";